module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1035-9db6654c01c6a8be5972a716c7cd8553.png";